import styled from 'styled-components';

export const StyledActionsCell = styled.div`
   display: flex;
   gap: 5px;
   justify-content: flex-end;
   width: 100%;
`;
StyledActionsCell.displayName = 'StyledActionsCell';
